import {
    PRODUCT_SIZE_PICKER_LOADING,
    PRODUCT_SIZE_PICKER_SELECT,
    PRODUCT_SIZE_PICKER_ERROR,
    PRODUCT_SIZE_PICKER_DATA,
} from './constants';

const initialState = {
    isLoading: true,
    selected: null,
    sizes: [],
    error: null,
};

const setLoading = (state) => ({ ...state, isLoading: true });
const setError = (state, error) => ({ ...state, error, isLoading: false });
const setData = (state, sizes) => ({ ...state, isLoading: false, sizes });
const selectData = (state, selected) => ({ ...state, selected });

const reducers = {
    [PRODUCT_SIZE_PICKER_LOADING]: setLoading,
    [PRODUCT_SIZE_PICKER_SELECT]: selectData,
    [PRODUCT_SIZE_PICKER_ERROR]: setError,
    [PRODUCT_SIZE_PICKER_DATA]: setData,
};

export default (state = initialState, action) => {
    if (reducers[action.type]) {
        return reducers[action.type](state, action.payload);
    }

    return state;
};